import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { MessageCircle, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const Whatsapp = () => {
  const { config } = useSite();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  if (loc.pathname.startsWith("/admin")) return null;
  const num = config.whatsapp_number || "919901947864";
  const msgs = config.whatsapp_messages || [];

  return (
    <div className="fixed bottom-24 right-6 z-[60] md:bottom-6">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.25 }}
            className="mb-3 w-[320px] max-w-[90vw] rounded-2xl bg-white shadow-2xl border border-ahm-teal/15 overflow-hidden"
            data-testid="whatsapp-panel"
          >
            <div className="bg-ahm-teal text-ahm-cream px-5 py-4 flex items-center justify-between">
              <div>
                <div className="font-display text-xl leading-tight">Chat with us</div>
                <div className="text-[11px] uppercase tracking-[0.2em] text-ahm-yellow">Typically reply in 10 min</div>
              </div>
              <button onClick={() => setOpen(false)} className="text-ahm-cream/80 hover:text-ahm-yellow" data-testid="whatsapp-close">
                <X size={18} />
              </button>
            </div>
            <ul className="p-3 space-y-2 max-h-[60vh] overflow-y-auto">
              {msgs.map((m, i) => (
                <li key={i}>
                  <a
                    href={`https://wa.me/${num}?text=${encodeURIComponent(m)}`}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`whatsapp-msg-${i}`}
                    className="block px-4 py-3 rounded-xl text-sm leading-snug bg-ahm-muted hover:bg-ahm-yellow/40 transition-colors text-ahm-teal"
                  >
                    {m}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-xl hover:scale-105 transition-transform"
        data-testid="whatsapp-floating-btn"
        aria-label="WhatsApp"
      >
        <MessageCircle size={22} />
        <span className="text-sm font-semibold hidden sm:inline">WhatsApp us</span>
      </button>
    </div>
  );
};

export default Whatsapp;
